<app-navbar></app-navbar>    

<div id="main-content" class="animated fadeIn">
  <div class="container-fluid">
    <!-- contenido-->
        <div class="block-header">
            <div class="row clearfix">
                <div class="col-md-6 col-sm-12">
                    <h1 class="color">Detalles de la Tarea</h1>
                    <div class="header">
                        <p id="back_proyects" style="cursor: pointer;" class="color"><i class="fa fa-angle-left " style="font-size: 19px;" aria-hidden="true"></i> Regresar / Proyectos /<span class="n_proyecto_activo" style="color: #a5a8ad;">Detalles</span></p>
                    </div>
                </div>            
                
            </div>
        </div>
        <!-- contenido -->
        <div id="ver_tareas" style="">

            <div class="container-fluid">
    
              
    
    
                <div class="row clearfix">
                    <div class="col-lg-6 col-md-12">
    
                      <div class="card">
                            <div class="header">
                                <h2>Información</h2>
                            </div>
                            <ul class="list-group">
                                <li class="list-group-item">
                                    <small class="text-muted">Proyecto: </small>
                                    <p class="mb-0" id="m_proyecto">Proyectos</p>
                                </li>
                                <li class="list-group-item">
                                    <small class="text-muted">Nombre de la Tarea: </small>
                                    <p class="mb-0" id="m_actividad">Actividad que no funciona2</p>
                                </li>
    
                                <li class="list-group-item">
                                    <small class="text-muted">Fecha: </small>
                                    <p class="mb-0" id="m_fecha">Miércoles 18 de Setiembre 2019 al Sabado 21 de Setiembre 2019</p>
                                </li>
                                <li class="list-group-item">
                                    <small class="text-muted">Importancia: </small>
                                    <p class="mb-0 badge badge-primary" id="m_importancia">Media</p>
                                </li>
                                <li class="list-group-item">
                                    <small class="text-muted">Estatus: </small>
                                    <p class="mb-0 badge badge-primary" id="m_estatus">Tarde</p>
                                </li>
    
                            </ul>
                        </div>
    
    
                        <div class="card c_grid c_yellow">
                          <div class="header">
                            <h2>Responsables</h2>
                          </div>
                            <div class="body text-center">
                              <div id="m_usuarios"><div class="row" style="margin-top: 10px;">                <div class="col-1">                 
                                   <img alt="image" src="public/img/avatar/avatar-1.png" class="rounded-circle " width="35">               </div>                <div class="col-11" style="margin-top: 5px;">David Rivera</div>              </div><div class="row" style="margin-top: 10px;">               
                                     <div class="col-1">                
                                          <img alt="image" src="public/img/avatar/287a50472754559b2c94463a2d9577d9.jpg" class="rounded-circle " width="35">
                                                      </div>                <div class="col-11" style="margin-top: 5px;">Jonathan Rivera</div>              </div></div>
                               
                            </div>
                        </div>
    
    
                    </div>
                    <div class="col-lg-6 col-md-12">
    
                       <div class="card">
                            <div class="header">
                                <h2>Tarea</h2>
                            </div>
                            <div class="body">
                               <ul class="list-group">
                                <li class="list-group-item">
                                    <small class="text-muted">Tarea: </small>
                                    <p class="mb-0" id="m_tarea">ACtividad2</p>
                                </li>
                                <li class="list-group-item">
                                    <small class="text-muted">Comentario: </small>
                                    <p class="mb-0" id="m_comentario">
                                        comne2
                                    </p>
                                </li>
    
    
                            </ul>
                        </div>
    
                            </div>
    
                        <div class="card">
                          <div class="header">
                            <h2>Comentario</h2>
                          </div>
                            <div class="body">
                                

                                <br>
                                <button class="btn btn-success btn-round pull-right" >Guardar</button>
                                <br>
                            </div>
                        </div>
                        <div class="card">
                            <div class="header">
                                <h2>Comentarios</h2>
                                <ul class="header-dropdown dropdown">
                                    <li><a href="" class="full-screen"><i class="icon-frame"></i></a></li>
    
                                </ul>
                            </div>
                            <div class="body">
    
                                <ul class="timeline">
    
                                       <div id="view_comentarios"></div>
    
    
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    
        </div>
        <!-- contenido -->
    </div>
</div>
